function handleWishProduct(wish) {
  const wishId = wish.dataset.id;
  const wishList = JSON.parse(localStorage.getItem('wish')) || [];
  let isExist = wishList.includes(wishId);
  wish.setAttribute('data-active', isExist);

  wish.addEventListener('click', function () {
    const wishList = JSON.parse(localStorage.getItem('wish')) || [];
    let isExist = wishList.includes(wishId);
    wish.setAttribute('data-active', isExist);

    if (isExist === true) {
      wish.setAttribute('data-active', 'false');
      isExist = false;
      wishList.splice(wishList.indexOf(wishId), 1);
    } else {
      wish.setAttribute('data-active', 'true');
      isExist = true;
      wishList.push(wishId);
    }

    localStorage.setItem('wish', JSON.stringify(wishList));
  });
}

const observer = new MutationObserver(function (mutationsList, observer) {
  mutationsList.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.classList) {
        const wishIcons = node.querySelectorAll('.wish-icon');
        wishIcons.forEach(handleWishProduct);
      }
    });
  });
});

const config = { childList: true, subtree: true };
const target = document.querySelector('.card-products-wrap');
if (target) {
  observer.observe(target, config);
}
document.querySelectorAll('.wish-icon').forEach(handleWishProduct);
